import { useHistory, useParams } from 'react-router-dom';
import styles from './SuperCollections.module.scss';
import CustomizeCollections from 'src/components/collection/CustomizeCollections';
import { useGetCollectionLazyQuery, useSaveCollectionLessonsMutation } from '@api/graphql-codegen'
import { useCallback, useEffect, useState } from 'react';
import Header from '@src/components/header/Header';
import NormalModal from '@src/components/modal/normal-modal/NormalModal';
import Button from '@src/components/button/Button';
import { useToast } from '@src/hooks';
import Spinner from '@src/components/spinner/Spinner';
import FooterPage from '@src/components/footer-page/FooterPage';

type Props = {
  id: string;
}

type Params = { id: string; }

function CollectionCustomize(props: Props) {
  const { id } = useParams<Params>();
  const history = useHistory();
  const { successToast } = useToast();

  const [saveModal, setSaveModal] = useState(false) 
  const [savingLessons, setSavingLessons] = useState<string[]>([])

  const [getCollection, {data: currentCollection, loading: collectionLoading}] = useGetCollectionLazyQuery({
    fetchPolicy: 'network-only'});

  useEffect(() => {
    if (id) {
      getCollection({
        variables: { input: { id: id } }
      });
    }
  }, [getCollection, id])

  const [saveCollectionLessons, {loading}] = useSaveCollectionLessonsMutation({
    onCompleted(data) {
      if(data.saveCollectionLessons) {
        successToast("Collection has been updated successfully!");
      }
      setSaveModal(false);
      history.goBack();
    },
  });

  const handleSave = useCallback((lessons: any[]) => {
    const collectionLessons = lessons.map(lesson => {
      return lesson.id
    })
    saveCollectionLessons({
      variables: {
        input: {
          collectionId: id,
          sllLessons: collectionLessons
        }
      }
    })
  }, [id, saveCollectionLessons]);

  const handleExit = useCallback((lessons: any[]) => {
    setSaveModal(true);
    const collectionLessons = lessons.map(lesson => {
      return lesson.id
    })
    setSavingLessons(collectionLessons)
  }, []);

  const handleUpdateCollection = useCallback(() => {
    saveCollectionLessons({
      variables: {
        input: {
          collectionId: id,
          sllLessons: savingLessons
        }
      }
    })
  }, [saveCollectionLessons, id, savingLessons])

  const handleLeaveUpdate = useCallback(() => {
    setSaveModal(false);
    history.goBack()
  }, [history])

  return (
    <>
      <Header />
      <div className={styles.customCollectionPage}>
        <CustomizeCollections
          collection={currentCollection?.getCollection}
          loadingCollection={collectionLoading}
          handleSave={handleSave}
          handleExit={handleExit}
          isDisabled={loading}
        />
        <FooterPage />
      </div>
      {saveModal && <NormalModal
        className={styles.saveModal}
        open={saveModal}
        onClose={() => setSaveModal(false)}
        title={<div style={{color: "#FF656E"}}>Unsaved changes</div>} 
        description={<div style={{color: "#FF656E"}}>You are about to leave this page without saving. All changes will be lost.</div>} 
        leftButton={<Button onClick={handleLeaveUpdate} label='LEAVE WITHOUT SAVING' className={styles.exitButton} />} 
        rightButton={<Button onClick={handleUpdateCollection} label='SAVE CHANGES' className={styles.saveButton} leftIcon={loading ? <Spinner width={20} height={20} /> : undefined} />}/>}
    </>
  );
}

export default CollectionCustomize;
